// ===================
// Kick things off!
// ===================
(function() {
	if (jQuery('#portfolio-app-static').length > 0) {
		PortfolioApp.initStatic();
	} else if (jQuery('#portfolio-app').length > 0) {
		PortfolioApp.init();
	}
})(jQuery);
